var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{attrs:{"id":"logo"}},[_c('img',{staticClass:"img-responsive",attrs:{"alt":"Logo","src":'https://cdn.finer.com.br/sistemas/logo_finer-comp-transp.png'}})])
}
var staticRenderFns = []

export { render, staticRenderFns }